import styled from 'astroturf/react';
import { PageTitle } from 'src/components/Page';

const Title = styled(PageTitle)`
  padding: 26px 48px 28px;
`;

const Wrapper = styled('div')`
  padding-top: 25px;

  button {
    margin: 16px 48px;
  }
`;

const Stack = styled('pre')`
  margin-left: 48px;
  font-size: var(--ph-text-sm);
  white-space: pre-wrap;
`;

export default {
  Title,
  Wrapper,
  Stack,
};
